import {
  type BudgetNotificationSettings,
  BudgetStatus,
  EMPTY_BUDGET_NOTIFICATION,
} from 'typings'

const USERNAME = String.raw`[^\s@]+`
const DOMAIN = String.raw`[^\s@]+`
const TLD = String.raw`[^\s@]+`

export const EMAIL_REGEX = new RegExp(`^${USERNAME}@${DOMAIN}\\.${TLD}$`)

export type BudgetAmount = {
  amount: number | undefined
  utilized?: number
  status: BudgetStatus
  notification?: BudgetNotificationSettings
}

export const EMPTY_BUDGET: BudgetAmount = {
  amount: undefined,
  utilized: 0,
  status: BudgetStatus.ACTIVE,
  notification: { ...EMPTY_BUDGET_NOTIFICATION },
}
